<form [formGroup]="siddhaYogaFamilyRetreatForm" (ngSubmit)="onSubmit()">
    <div class="step-container">
      <ng-template #labelFamilyRetreat>Family Retreat</ng-template>
      <div class="step-title">Family Retreat</div>

      {{siddhaYogaFamilyRetreatForm.value | json}}

      <div class="alert-box">
        <div class="alert-title"><i class="fas fa-info-circle" nbTooltip="This is a tooltip" nbTooltipPlacement="top"></i>
          &nbsp; Essay Response Instructions</div>
        <div class="alert-text">
          <ul>
            <li>Write an essay response to each of the following questions. Please be specific in your answers and use examples wherever possible (minimum 100 words).</li>
            <li>Your responses should demonstrate that:</li>
            <ul>
              <li>You have committed yourself to a conscious and sustained engagement with Siddha Yoga meditation,</li>
              <li>You have taken responsibility for your learning, your experience and your spiritual path,</li>
              <li>You have made an effort to clearly articulate your understanding and experience.</li>
            </ul>
          </ul>
        </div>
      </div>
      
      <br>
  
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputChildBehaviorChanges">1. As a result of your child’s/children’s regular participation in the children/family satsang, what specific positive changes in behaviour have you observed in them? How do you nurture these changes? Give a specific example.</label>
          <textarea
            class="form-control"
            id="inputChildBehaviorChanges"
            formControlName="childBehaviorChanges"
            rows="3"
            placeholder="Describe changes in behavior and nurturing examples"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaFamilyRetreatForm.get('childBehaviorChanges')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('childBehaviorChanges')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('childBehaviorChanges')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('childBehaviorChanges')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputParentInsights">2. Kindly share your specific learning or insights which you have gained from your regular participation in the Siddha Yoga family satsang, and which you cherish as parents.</label>
          <textarea
            class="form-control"
            id="inputParentInsights"
            formControlName="parentInsights"
            rows="3"
            placeholder="Share your learnings or insights"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaFamilyRetreatForm.get('parentInsights')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('parentInsights')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('parentInsights')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('parentInsights')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputSiddhaYogaMessage">3. How are you studying and practising the Siddha Yoga message for this current year? How are your children studying and practising it?</label>
          <textarea
            class="form-control"
            id="inputSiddhaYogaMessage"
            formControlName="siddhaYogaMessage"
            rows="3"
            placeholder="Describe how you and your children are practising the message"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaFamilyRetreatForm.get('siddhaYogaMessage')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('siddhaYogaMessage')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('siddhaYogaMessage')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('siddhaYogaMessage')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputSiddhaYogaPractices">4. Which Siddha Yoga practices are you regularly engaged with? What impact do these have on your family life?</label>
          <textarea
            class="form-control"
            id="inputSiddhaYogaPractices"
            formControlName="siddhaYogaPractices"
            rows="3"
            placeholder="Describe Siddha Yoga practices and their impact on your family"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaFamilyRetreatForm.get('siddhaYogaPractices')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('siddhaYogaPractices')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('siddhaYogaPractices')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('siddhaYogaPractices')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputPurposeParticipation">5. Why do you wish to participate in a Siddha Yoga family retreat at Gurudev Siddha Peeth?</label>
          <textarea
            class="form-control"
            id="inputPurposeParticipation"
            formControlName="purposeParticipation"
            rows="3"
            placeholder="State your purpose for participating in the retreat"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaFamilyRetreatForm.get('purposeParticipation')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('purposeParticipation')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('purposeParticipation')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('purposeParticipation')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <div class="form-group col-12 mb-3">
          <label for="inputContribution">6. What do you think you and your children can contribute to the Siddha Yoga family retreat at Gurudev Siddha Peeth?</label>
          <textarea
            class="form-control"
            id="inputContribution"
            formControlName="contribution"
            rows="3"
            placeholder="Describe your and your children's contributions"
            maxlength="1000"
          ></textarea>
          <div *ngIf="submitted && siddhaYogaFamilyRetreatForm.get('contribution')?.invalid" class="text-danger">
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('contribution')?.errors?.['required']">This field is required.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('contribution')?.errors?.['minlength']">Minimum length is 10 characters.</div>
            <div *ngIf="siddhaYogaFamilyRetreatForm.get('contribution')?.errors?.['maxlength']">Maximum length is 1000 characters.</div>
          </div>
        </div>
      </div>
  
      <!-- Buttons -->
      <div class="d-flex justify-content-between">
        <div>
          <button class="btn savedraftbtn" type="button">SAVE AS DRAFT</button>
        </div>
        <div>
          <button type="button" class="prevbtn" (click)="goToBack()">PREVIOUS</button>
          <button type="submit" class="nextbtn">NEXT</button>
        </div>
      </div>
    </div>
  </form>
  